export default {
  currentEmployee: null,
  employeeDataOptions: {},
  employees: [],
  filteredEmployees: [],
  employeesLoaded: false
};
